module.exports = __webpack_public_path__ + "img/list.68fbcade.png";